import DissentedStubModel from './dissented-stub'

export default class ConsentedStubModel extends DissentedStubModel {
  public load = () => {
    super.load()
    const purposesAllowed = this.vendorList.purposes.map(p => p.id)
    const vendorsAllowed = this.vendorList.vendors.map(v => v.id)
    this.consentData.setPurposesAllowed(purposesAllowed)
    this.consentData.setVendorsAllowed(vendorsAllowed)
    this.metadata = this.consentData.getConsentString()
    this.consented = true
  }
}
